@let showsSelected = challenge().isSelected || previewSelected();

<div
  class="card"
  [id]="challenge().offerId"
  [style]="{
    border: config().cardStyles.border,
    boxShadow: withShadow() ? config().cardStyles.boxShadow : 'none',
  }"
>
  <div class="header">
    <img
      [src]="config().header.backgroundImage.url"
      [alt]="config().header.backgroundImage.bannerAriaLabel"
    />
    @let title = config().header.backgroundImage.title;
    @if (title) {
      <p
        class="title"
        [innerHTML]="title.text"
        [style.color]="title.color"
        [style.fontFamily]="title.fontFamily"
      ></p>
    }
  </div>

  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style.backgroundColor]="
      challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor
    "
  >
    @let labelConfig = config().subHeader.title;
    @if (labelConfig) {
      <p
        class="label"
        [style]="{
          color: labelConfig.color,
          fontFamily: labelConfig.fontFamily,
        }"
      >
        {{ labelConfig.label }}
      </p>
    }
  </div>

  <div class="card-content" data-cy="frequency-card-content">
    @if (challenge().progress < challenge().target) {
      <div
        class="card-body"
        data-cy="frequency-card-content"
        [class.opacity-option]="!showsSelected"
      >
        <img
          class="bag"
          [alt]="
            config().body.picture.alternativeText
              | replaceVars: challenge().rewardRatio
          "
          [src]="config().body.picture.imageUrl"
        />

        <div class="visit-summary">
          <div
            class="wording"
            [style]="{
              color: config().body.summary.color,
              fontFamily: config().body.summary.fontFamily,
            }"
          >
            <p class="win-text">{{ config().body.summary.text }}</p>
            <div class="target">{{ challenge().rewardRatio }}€</div>
          </div>
        </div>

        <div class="visit-container">
          <span class="number" data-cy="progress">{{
            challenge().progress
          }}</span>
          <span class="sign">/</span>
          <span class="total" data-cy="target">{{ challenge().target }}</span>
          <span
            class="wording"
            [style]="{
              color: config().body.visitWording.color,
              fontFamily: config().body.visitWording.fontFamily,
            }"
          >
            {{ config().body.visitWording.text }}
          </span>
        </div>
      </div>
    }

    <!-- Win Card -->
    @if (challenge().isCompleted) {
      <b2c-win-card class="win-container" [amount]="challenge().rewardRatio" />
    }
    <!-- Selection Button -->
    @if (!showsSelected) {
      <div class="selection-section">
        <b2c-selection-button
          b2cElement
          [phase]="phase()"
          [challenge]="challenge()"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }

    @if (challenge().canBeUnselected(phase())) {
      <div class="unselect-footer">
        <b2c-unselection-button
          [phase]="phase()"
          [challenge]="challenge()"
          [isBisCampaign]="isBisCampaign()"
          [isEventChallenge]="isEventChallenge()"
        />
      </div>
    }
  </div>
</div>
